import React from 'react';
import { Paper, Box, Typography, Stack } from '@mui/material';
import { IHourlyPeak } from 'services/SchoolClass/types';

interface Props {
  data: IHourlyPeak[];
}

export function ClassHourlyPeaks({ data }: Props) {
  return (
    <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid', borderColor: 'divider', bgcolor: 'background.paper', minHeight: 360, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Typography variant="h6" fontWeight="bold" color="text.primary">Picos de Entrada</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>Volume de acesso hoje</Typography>
      
      <Stack spacing={3} sx={{ flex: 1, justifyContent: 'center' }}>
        {data.map((bar, i) => (
          <Box key={i}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
              <Typography variant="caption" color="text.secondary">{bar.timeRange}</Typography>
              <Typography variant="caption" color="text.secondary">{bar.percentage}%</Typography>
            </Box>
            <Box sx={{ width: '100%', height: 8, bgcolor: 'divider', borderRadius: 4, overflow: 'hidden' }}>
              <Box sx={{ 
                width: `${bar.percentage}%`, height: '100%', 
                bgcolor: bar.percentage > 50 ? 'primary.main' : 'warning.main', 
                opacity: bar.percentage === 0 ? 0 : 0.8, borderRadius: 4 
              }} />
            </Box>
          </Box>
        ))}
      </Stack>
    </Paper>
  );
}